export const placeholder = 'Start typing...';
export const componentClass = 'acumen-multi-select';
